@use "../../../../variables" as *;

.product-info {
  margin-top: 2rem;
  margin-bottom: 0.75rem;

  .product-tag {
    display: inline-block;
  }

  .description {
    font-weight: 400;
    color: $grey-text;
    font-size: 2rem;
    line-height: 2.25rem;
    margin-top: 2.5rem;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .price-container {
    color: $grey-text;
    font-size: 1.25rem;
    line-height: 1.25rem;
    margin-top: 0.813rem;
    font-weight: 300;

    .sale-container {
      margin-bottom: 4.438rem;
      display: flex;

      div {
        display: flex;
        flex-direction: column;
      }

      .original-price-container {
        padding-left: 0.844rem;
        margin-left: 0.844rem;
        border-left: 0.063rem solid $grey;

        span:first-child {
          margin-bottom: 0.438rem;
        }

        .original-price {
          text-decoration: line-through;
        }
      }

      .hide-original-price-container {
        display: none;
      }

      .sale-price-with-original-price {
        color: #e4172e;
      }

      .sale-price {
        color: #e4172e;
        margin: 0;
      }

      .sale-price-container {
        span:first-child {
          margin-bottom: 0.438rem;
        }

        .original-price {
          text-decoration: line-through;
        }
      }
    }

    .current-price-container {
      margin-bottom: 0.875rem;

      .current-exchange-price {
        padding-left: 0.844rem;
        margin-left: 0.844rem;
        border-left: 0.063rem solid $grey;
      }
    }
  }

  .brand-product-number {
    //margin-top: 5rem;
    margin-top: 2.125rem;
    display: flex;
    justify-content: space-between;
    align-items: baseline;

    .brand {
      width: 25%;
    }

    .product-number {
      font-weight: 300;
      color: $grey-text-light;
      font-size: 0.75rem;
      line-height: 0.75rem;
    }
  }

  .price-caption {
    font-size: 0.8125rem;
    letter-spacing: 0.040625rem;
    line-height: 1.25rem;
    color: $grey-text;
  }
}